import { Injectable, inject } from '@angular/core';
import { Firestore } from '@angular/fire/firestore';
import { FirebaseStorage, UploadTaskSnapshot, deleteObject, getDownloadURL, getStorage, ref, uploadBytesResumable } from '@angular/fire/storage';

import { Observable, fromEventPattern, from, of } from 'rxjs';
import { map, catchError, } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class FileService {
  storage: FirebaseStorage;

  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  private firestore = inject(Firestore);

  constructor() {
    this.storage = getStorage()
  }


  /**
   * Uploads file to firebase storage/ returns observable containing task, upload percentage, and downloadURL
   * @param filePath string
   * @param file File
   * @returns Observable<{task: any; percentage: Observable<number>; downloadURL: Observable<string>; }
   */
  // uploadFileAndGetMetadata(
  //   filePath: string,
  //   file: File
  // ): Observable<{
  //   task: any;
  //   percentage: Observable<number>;
  //   downloadURL: Observable<string>;
  // }> {
  //   const fileRef = ref(this.storage, filePath);
  //   const task = uploadBytesResumable(fileRef, file);

  //   const percentage = fromEventPattern<UploadTaskSnapshot>(
  //     (handler) => task.on('state_changed', handler)
  //   ).pipe(
  //     map(snapshot => (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
  //   );


  //   // Get the download URL only after the upload is successfully completed
  //   const downloadURL = percentage.pipe(
  //     filter(percentage => percentage === 100), // Check if the upload is successful
  //     switchMap(() => from(getDownloadURL(fileRef))),
  //     catchError(error => {
  //       console.error("Error during file upload:", error);
  //       return of('');
  //     })
  //   );

  //   percentage.subscribe(progress => {
  //     console.log(`Upload Progress: ${progress}%`)
  //     if(progress === 100){
  //       console.log(this.re(fileRef))
  //     }
  //   });
  //   downloadURL.subscribe(url => console.log(`Download URL: ${url}`));

  //   return of({
  //     task: task,
  //     percentage: percentage,
  //     downloadURL: downloadURL
  //   });
  // }

  uploadFileAndGetMetadata(
    filePath: string,
    file: File
  ): Observable<{
    task: any;
    percentage: Observable<number>;
    downloadURL: Observable<string>;
  }> {
    const fileRef = ref(this.storage, filePath);
    const task = uploadBytesResumable(fileRef, file);

    // Observable for tracking upload percentage
    const percentage = fromEventPattern<UploadTaskSnapshot>(
      (handler) => task.on('state_changed', handler)
    ).pipe(
      map(snapshot => (snapshot.bytesTransferred / snapshot.totalBytes) * 100)
    );

    // Observable for download URL retrieval
    const downloadURL = new Observable<string>((observer) => {
      task.on(
        'state_changed',
        null,
        (error) => {
          console.error('Error during upload:', error);
          observer.error(error);
        },
        async () => {
          try {
            const url = await getDownloadURL(fileRef);
            observer.next(url);
            observer.complete();
          } catch (error) {
            console.error('Error fetching download URL:', error);
            observer.error(error);
          }
        }
      );
    });

    // Return task, percentage, and downloadURL as observables
    return new Observable(observer => {
      observer.next({
        task: task,
        percentage: percentage,
        downloadURL: downloadURL
      });
      observer.complete();
    });
  }


  /**
   * Delete a file from Firebase Storage
   * @param filePath string
   * @returns Observable<any>
   */
  deleteFile(filePath: string): Observable<any> {
    const fileRef = ref(this.storage, filePath);
    return from(deleteObject(fileRef));
  }

  /**
   * Check to see if the file Exists
   * @param filePath
   * @returns Observable<Boolean>
   */
  checkFileExists(filePath: string): Observable<boolean> {
    const fileRef = ref(this.storage, filePath);
    return from(getDownloadURL(fileRef)).pipe(
      map(url => !!url),
      catchError((error) => {
        console.error(error);
        return of(false);
      })
    );
  }


  /**
   * Resize an image file to a square ratio
   * @param file File
   * @param squareSize number
   * @returns Promise<File>
   */
  resizeImageToSquare(file: File, squareSize: number): Promise<File> {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onload = (event: any) => {
        const imgElement = new Image();
        imgElement.src = event.target.result;

        imgElement.onload = () => {
          const canvas = document.createElement('canvas');
          canvas.width = squareSize;
          canvas.height = squareSize;

          const ctx = canvas.getContext('2d');
          if (!ctx) {
            reject(new Error('Unable to get canvas context'));
            return;
          }

          ctx.clearRect(0, 0, squareSize, squareSize);

          const scale = Math.min(imgElement.width / squareSize, imgElement.height / squareSize);
          const x = (imgElement.width / 2) - (squareSize / 2) * scale;
          const y = (imgElement.height / 2) - (squareSize / 2) * scale;

          ctx.drawImage(imgElement, x, y, squareSize * scale, squareSize * scale, 0, 0, squareSize, squareSize);

          canvas.toBlob(blob => {
            if (blob) {
              resolve(new File([blob], file.name, {
                type: 'image/png'
              }));
            } else {
              reject(new Error('Canvas to Blob conversion failed'));
            }
          }, 'image/png');
        };
      };
      reader.onerror = error => reject(error);
      reader.readAsDataURL(file);
    });
  }


}
